<template lang="pug">
  div
    template(v-if="$store.getters.accountType == 7")
      b-row
        .col-md-12.col-lg-12.col-xl-12
          panel(:title='$t("ui.type")')
            .col-md-3.col-lg-3.col-xl-3
              b-input-group(:prepend="$t('ui.system_type')" size="sm")
                b-form-select(
                  ref="system_type"
                  v-model="system_type"
                  size="sm"
                )
                  option(value="credit") {{ $t("ui.credit") }}
                  option(value="cash") {{ $t("ui.cash") }}
      template(v-if="systemType == 'cash'")
        settlementListCash
      template(v-else)
        settlementListCredit
    template(v-else)
      template(v-if="isCashMode($store.getters.cashMode)")
        settlementListCash
      template(v-else)
        settlementListCredit
</template>

<script>
import settlementListCredit from "@/views/settlement/_settlementListCredit.vue"
import settlementListCash from "@/views/settlement/_settlementListCash.vue"

export default {
  components: {
    settlementListCredit,
    settlementListCash
  },
  data() {
    return {
      system_type: "credit"
    }
  },
  computed: {
    systemType() {
      return this.system_type;
    },
  },
  mounted: function() {
    this.$helpers.getSchedule()
  },
  methods: {
    isCashMode() {
      return this.$store.getters.cashMode //bool
    }
  }
};
</script>